module.exports = __webpack_public_path__ + "static/media/logo-smaller.9b7b6084.png";